/** Maps the composer's client picker between its menu values and a client id. */
export class ComposerClientMenuHelper {
  /** A sentinel for null, which is "every client the viewer can reach". */
  static readonly ALL_CLIENTS_VALUE = 'all';

  static readonly ALL_CLIENTS_LABEL = 'All clients';

  static toValue(clientId: number | null): string {
    return clientId === null
      ? ComposerClientMenuHelper.ALL_CLIENTS_VALUE
      : String(clientId);
  }

  static toClientId(value: string): number | null {
    return value === ComposerClientMenuHelper.ALL_CLIENTS_VALUE
      ? null
      : Number(value);
  }
}
